module.exports = __webpack_public_path__ + "static/media/HELMET-BNB.f501b822.svg";